import { HonorariumLiquidationDTO } from '../../dto/HonorariumLiquidationDTO';

interface LiquidationPaymentStatusTagProps {
    /** null mientras la liquidación está abierta. */
    paymentStatus: HonorariumLiquidationDTO['paymentStatus'];
}

/** Pago de una liquidación cerrada (DS §3.4): pendiente si a algún profesional le falta cobrar. */
export default function LiquidationPaymentStatusTag({ paymentStatus }: LiquidationPaymentStatusTagProps) {
    if (paymentStatus === 'PAID') return <span className="md-tag md-tag-ok">Pagada</span>;
    if (paymentStatus === 'PENDING') return <span className="md-tag md-tag-warn">Pendiente de pago</span>;
    return <>—</>;
}
